var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipsisVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#78A6BE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 12C21.1044 12 21.9998 11.1046 21.9998 10C21.9998 8.89543 21.1044 8 19.9998 8C18.8953 8 17.9998 8.89543 17.9998 10C17.9998 11.1046 18.8953 12 19.9998 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 22.0005C21.1044 22.0005 21.9998 21.1051 21.9998 20.0005C21.9998 18.8959 21.1044 18.0005 19.9998 18.0005C18.8953 18.0005 17.9998 18.8959 17.9998 20.0005C17.9998 21.1051 18.8953 22.0005 19.9998 22.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 31.9995C21.1044 31.9995 21.9998 31.1041 21.9998 29.9995C21.9998 28.8949 21.1044 27.9995 19.9998 27.9995C18.8953 27.9995 17.9998 28.8949 17.9998 29.9995C17.9998 31.1041 18.8953 31.9995 19.9998 31.9995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVertical);
export default __webpack_public_path__ + "static/media/ellipsis-vertical.4720c0ea23b30b3853cc117c5c4e5d6e.svg";
export { ForwardRef as ReactComponent };